export class JobQueueClass {
    constructor() {
        this.jobQueue = [];
        this.running = false;
    }

    async push(fn) {
        // we need to expose the `resolve` and `reject` functions
        // rather than have them called directly. This allows
        // the client who wants a job run to `await` on the
        // `jobQueue.push` return value, and allows the jobQueue
        // `runNextJob` to have the responsibility of
        // resolving or rejecting.
        let resolver;
        let rejecter;

        const delayedJob = new Promise((resolve, reject) => {
            resolver = resolve;
            rejecter = reject;
        });

        const resolvableJob = {
            fn,
            resolve: resolver,
            reject: rejecter,
        };

        this.jobQueue.push(resolvableJob);
        this.runNextJob();

        return delayedJob;
    }

    async runNextJob() {
        if (this.jobQueue.length > 0 && !this.running) {
            this.running = true;

            const job = this.jobQueue.shift();

            try {
                const val = await job.fn.call();

                job.resolve(val);
            } catch (e) {
                job.reject(e);
            }

            this.running = false;

            return this.runNextJob();
        }
    }

    async flushQueue() {
        // Awaiting the results of push function forces all prior queued calls to resolve first
        return await this.push(() => {});
    }
}

export const jobQueue = new JobQueueClass();
